import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  showText?: boolean;
  size?: "sm" | "md" | "lg";
  onClick?: () => void;
}

const Logo = ({ className, showText = true, size = "md", onClick }: LogoProps) => {
  const sizeClasses = {
    sm: { img: "h-6 w-6", text: "text-xl" },
    md: { img: "h-8 w-8", text: "text-2xl" },
    lg: { img: "h-12 w-12", text: "text-4xl" },
  };

  return (
    <div 
      className={cn(
        "flex items-center gap-2",
        onClick && "cursor-pointer",
        className
      )}
      onClick={onClick}
    >
      <picture>
        <source srcSet="/logo.png" type="image/png" />
        <img 
          src="/logo.png" 
          alt="Explaora logo" 
          className={sizeClasses[size].img}
          loading="eager"
          decoding="async"
          width={size === "lg" ? 48 : size === "md" ? 32 : 24}
          height={size === "lg" ? 48 : size === "md" ? 32 : 24}
          fetchPriority="high"
        />
      </picture>
      {showText && (
        <span className={cn(
          "font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent",
          sizeClasses[size].text
        )}>
          Explaora
        </span>
      )}
    </div>
  );
};

export default Logo;
